<div class="container-space-between">
  <app-page-title
    [title]="translations.title"
    [backText]="translations.titleBackText"
    [goBackRoute]="routingEnum.USER_SETTINGS"
  ></app-page-title>
</div>

@if (isLoading()) {
  <app-loader></app-loader>
} @else {
  <form [formGroup]="formGroup" class="content-container">
    <section>
      <div class="section-header">
        <h3>{{ translations.yourProfile }}</h3>
      </div>

      <div class="section-content">
        <app-input
          formControlName="firstName"
          class="no-padding-bottom"
          [label]="translations.firstName"
        ></app-input>
        <app-input
          formControlName="lastName"
          class="no-padding-bottom"
          [label]="translations.lastName"
        ></app-input>
        <app-input formControlName="email" [label]="translations.email" type="email"></app-input>
      </div>
    </section>

    <section>
      <div class="section-header">
        <h3>{{ translations.language }}</h3>
        <p class="section-description">{{ translations.customizeLanguage }}</p>
      </div>

      <div class="section-content">
        <app-language-selector
          (languageChanged)="onLanguageChanged($event)"
          [label]="translations.language"
          [setLanguageOnChange]="false"
        ></app-language-selector>
      </div>
    </section>
  </form>

  <app-entity-save-footer
    (save)="onSave()"
    [showCancelButton]="false"
    [isDisabled]="isSubmitButtonDisabled()"
  ></app-entity-save-footer>
}
